import { useEffect, useState } from "react";
import { myCompany } from "./directory";

// module-level cache so the brand never flashes a placeholder between pages
let cached = null;
let inflight = null;

export const useMyCompany = () => {
  const [company, setCompany] = useState(cached);
  useEffect(() => {
    if (cached) return;
    inflight = inflight || myCompany();
    inflight
      .then((data) => {
        cached = data;
        setCompany(data);
      })
      .catch(() => setCompany(null))
      .finally(() => {
        inflight = null;
      });
  }, []);
  return company;
};

export const clearCompanyCache = () => {
  cached = null;
  inflight = null;
};
